import { useEffect } from 'react';
import { Row, Button, Card, Col } from '../../ui/ot';
import FrontendNews from '../../news/views/frontend_news';


const News = ({ prefixTitle }) => {
  useEffect(() => {
    document.title = `${prefixTitle} | 最新消息`;
  }, [prefixTitle]);

  return (
    <Row gutter={[8, 8]}
      justify={'center'}
      align={'middle'}
      style={{
        padding: "1rem"
      }}>
      <Col span={24}>
        <FrontendNews
          newRoute={'/officialweb/frontend/new'}

        ></FrontendNews>
      </Col>
    </Row>
  );
};

export default News;
